import { useEffect, useRef, useState } from "react";

import { useLocation } from "react-router-dom";

import { Button } from "reactstrap";

//Util
import { ICONES_BOTAO, ICONES_MENSAGEM } from "@/frontend/utils/icones";
import { fn_existeNovaVersao } from "@/frontend/utils/versao";

//Intervalo mínimo entre duas consultas da versão publicada
const INTERVALO_MIN_CONSULTA_MS = 60 * 1000;

//Intervalo da consulta periódica (para a aba que fica aberta na mesma tela)
const INTERVALO_CONSULTA_PERIODICA_MS = 5 * 60 * 1000;

/*
 * Avisa que uma nova versão do sistema foi publicada, com o botão para atualizar a tela.
 * Não recarrega sozinho, para o usuário não perder o que estiver digitando.
 * A versão publicada é consultada ao trocar de tela, ao voltar para a aba do navegador e periodicamente.
 */
export default function AvisoNovaVersao() {
  const location = useLocation();

  //### USE REF ###
  const ultimaConsultaRef = useRef(0);

  //### USE STATE ###
  const [existeNovaVersao, setExisteNovaVersao] = useState(false);

  //### FUNÇÕES ###
  //Consulta a versão publicada, respeitando o intervalo mínimo entre as consultas
  async function verificarNovaVersao() {
    if (Date.now() - ultimaConsultaRef.current < INTERVALO_MIN_CONSULTA_MS) {
      return;
    }

    ultimaConsultaRef.current = Date.now();

    if (await fn_existeNovaVersao()) {
      setExisteNovaVersao(true);
    }
  }

  //### USE EFFECT ###
  //Ao trocar de tela
  useEffect(() => {
    verificarNovaVersao();
  }, [location.pathname]);

  //Ao voltar para a aba do navegador e periodicamente
  useEffect(() => {
    function handleVisibilidade() {
      if (document.visibilityState == "visible") {
        verificarNovaVersao();
      }
    }

    document.addEventListener("visibilitychange", handleVisibilidade);
    const timer = setInterval(
      verificarNovaVersao,
      INTERVALO_CONSULTA_PERIODICA_MS,
    );

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilidade);
      clearInterval(timer);
    };
  }, []);

  if (!existeNovaVersao) {
    return null;
  }

  return (
    <div className="aviso-nova-versao" role="alert">
      <span className="me-2">{ICONES_MENSAGEM.AVISO}</span>
      <span className="me-3">
        Uma nova versão do sistema foi publicada. Salve o que estiver fazendo e
        atualize a tela.
      </span>

      <Button
        name="btnAtualizarVersao"
        size="sm"
        color="primary"
        onClick={() => window.location.reload()}
      >
        {ICONES_BOTAO.RELOAD} Atualizar
      </Button>
    </div>
  );
}
